/* Amelia & Charlotte — Premium Order Tracking. Looks up orders by email via
 * the /apps/track-order App Proxy, which forwards to our Cloudflare Worker. */
(function () {
  'use strict';

  var PLACEHOLDER_COLORS = ['10,31,68', '107,79,42', '18,29,29', '51,20,4', '18,45,84'];

  var STEPS = [
    'order-confirmed',
    'payment-confirmed',
    'preparing',
    'quality-check',
    'packed',
    'label-created',
    'handed-to-carrier',
    'in-transit',
    'arrived-in-destination',
    'handed-to-local-courier',
    'out-for-delivery',
    'delivered'
  ];

  var STEP_LABELS = {
    'order-confirmed': 'Order Confirmed',
    'payment-confirmed': 'Payment Confirmed',
    preparing: 'Preparing Your Order',
    'quality-check': 'Quality Check',
    packed: 'Carefully Packed',
    'label-created': 'Shipping Label Created',
    'handed-to-carrier': 'Handed to International Carrier',
    'in-transit': 'International Shipment in Progress',
    'arrived-in-destination': 'Arrived in Destination Country',
    'handed-to-local-courier': 'Handed to Local Courier',
    'out-for-delivery': 'Out for Delivery',
    delivered: 'Delivered'
  };

  var STATUS_TITLES = {
    'order-confirmed': 'Your order has been confirmed',
    'payment-confirmed': 'Your payment has been confirmed',
    preparing: "We're preparing your order with care",
    'quality-check': 'Your order is going through quality check',
    packed: 'Your order has been carefully packed',
    'label-created': 'Your shipping label has been created',
    'handed-to-carrier': 'Your order is with our international carrier',
    'in-transit': 'Your order is on its way',
    'arrived-in-destination': 'Your order has arrived in the destination country',
    'handed-to-local-courier': 'Your order is with the local courier',
    'out-for-delivery': 'Your order is out for delivery',
    delivered: 'Your order has been delivered'
  };

  function placeholderImage(letter, rgb) {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200">' +
      '<rect width="200" height="200" fill="rgb(' + rgb + ')"/>' +
      '<text x="100" y="116" font-family="Georgia, serif" font-size="72" fill="rgba(255,255,255,0.9)" text-anchor="middle">' + letter + '</text>' +
      '</svg>';
    return 'data:image/svg+xml;base64,' + btoa(svg);
  }

  function pickPlaceholderColor(title) {
    var hash = 0;
    for (var i = 0; i < title.length; i++) {
      hash = (hash * 31 + title.charCodeAt(i)) >>> 0;
    }
    return PLACEHOLDER_COLORS[hash % PLACEHOLDER_COLORS.length];
  }

  function formatPrice(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
    } catch (err) {
      return amount + ' ' + currency;
    }
  }

  function fetchOrderByEmail(email) {
    return fetch('/apps/track-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim() })
    }).then(function (response) {
      if (!response.ok && response.status !== 400) {
        throw new Error('request_failed');
      }
      return response.json();
    });
  }

  function revealSection(section) {
    section.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        section.classList.add('is-visible');
      });
    });
  }

  function renderProgress(order) {
    var currentIndex = STEPS.indexOf(order.currentStep);
    var steps = document.querySelectorAll('#ac-track-progress .ac-track-progress__step');
    var delayStep = 70;

    steps.forEach(function (stepEl, index) {
      var step = stepEl.getAttribute('data-step');
      var stepIndex = STEPS.indexOf(step);
      var isComplete = stepIndex <= currentIndex;

      stepEl.classList.toggle('is-complete', isComplete);
      stepEl.classList.toggle('is-current', stepIndex === currentIndex);

      var iconEl = stepEl.querySelector('.ac-track-progress__icon');
      if (iconEl) {
        iconEl.style.animationDelay = isComplete ? (index * delayStep) + 'ms' : '';
      }

      var dateEl = stepEl.querySelector('[data-step-date]');
      if (dateEl) {
        dateEl.textContent = order.milestoneDates[step] || '—';
      }
    });
  }

  function scrollToCurrentMilestone() {
    var currentEl = document.querySelector('#ac-track-progress .ac-track-progress__step.is-current')
      || document.querySelector('#ac-track-progress .ac-track-progress__step.is-complete:last-of-type');

    if (currentEl) {
      currentEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  var CONFIDENCE_DISPLAY = {
    'on-schedule': { emoji: '🟢', label: 'On Schedule' },
    'slight-delay': { emoji: '🟡', label: 'Slight Delay' },
    'delivery-delay': { emoji: '🔴', label: 'Delivery Delay' }
  };

  function renderStatusCard(order) {
    document.getElementById('ac-track-status-title').textContent = STATUS_TITLES[order.currentStep];
    document.getElementById('ac-track-status-meta').textContent =
      'Order ' + order.number + ' · ' + STEP_LABELS[order.currentStep];

    var confidenceEl = document.getElementById('ac-track-confidence');
    var confidence = CONFIDENCE_DISPLAY[order.confidence];

    if (confidence) {
      confidenceEl.textContent = confidence.emoji + ' ' + confidence.label;
      confidenceEl.hidden = false;
    } else {
      confidenceEl.hidden = true;
    }
  }

  function renderProgressBar(order) {
    var fillEl = document.getElementById('ac-track-progress-bar-fill');
    var barEl = document.getElementById('ac-track-progress-bar');
    var percent = order.progressPercent || 0;

    fillEl.style.width = percent + '%';
    barEl.setAttribute('aria-valuenow', percent);
  }

  function renderEstimate(order) {
    var estimateEl = document.getElementById('ac-track-estimate');

    if (!order.estimatedDelivery) {
      estimateEl.hidden = true;
      return;
    }

    document.getElementById('ac-track-estimate-range').textContent =
      order.estimatedDelivery.start + ' – ' + order.estimatedDelivery.end;
    estimateEl.hidden = false;
  }

  function renderDeliveredInfo(order) {
    document.getElementById('ac-track-delivered-info').hidden = order.currentStep !== 'delivered';
  }

  function renderSummary(order) {
    var itemsWrap = document.getElementById('ac-track-summary-items');
    itemsWrap.innerHTML = '';

    order.items.forEach(function (item) {
      var image = placeholderImage(item.title.charAt(0).toUpperCase(), pickPlaceholderColor(item.title));
      var price = formatPrice(item.priceAmount, item.priceCurrency);

      var row = document.createElement('div');
      row.className = 'ac-track-summary-item';
      row.innerHTML =
        '<div class="ac-track-summary-item__image"><img src="' + image + '" alt="" width="200" height="200" loading="lazy"></div>' +
        '<div>' +
        '<p class="ac-track-summary-item__title">' + item.title + '</p>' +
        '<p class="ac-track-summary-item__meta">Qty ' + item.qty + ' · ' + price + '</p>' +
        '</div>';
      itemsWrap.appendChild(row);
    });

    document.getElementById('ac-track-summary-order-number').textContent = order.number;
    document.getElementById('ac-track-summary-order-date').textContent = order.orderDate;
    document.getElementById('ac-track-summary-address').textContent = order.address;
    document.getElementById('ac-track-summary-carrier').textContent = order.carrier;
  }

  function showError(message) {
    var errorEl = document.getElementById('ac-track-error');
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function hideError() {
    var errorEl = document.getElementById('ac-track-error');
    errorEl.hidden = true;
  }

  function hideResultSections() {
    ['ac-track-status', 'ac-track-summary'].forEach(function (id) {
      var section = document.getElementById(id);
      section.classList.remove('is-visible');
      section.hidden = true;
    });
  }

  function init() {
    var form = document.getElementById('ac-track-form');
    if (!form) return;

    var submitButton = document.getElementById('ac-track-submit');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideError();

      var email = document.getElementById('ac-track-email').value;

      if (!email.trim()) {
        showError('Please enter the email address you used when placing your order.');
        return;
      }

      submitButton.classList.add('is-loading');
      submitButton.disabled = true;

      fetchOrderByEmail(email)
        .then(function (data) {
          submitButton.classList.remove('is-loading');
          submitButton.disabled = false;

          if (data.error === 'invalid_email') {
            hideResultSections();
            showError('Please enter a valid email address.');
            return;
          }

          if (!data.found) {
            hideResultSections();
            showError("We couldn't find an order for that email address. Please check and try again, or contact support below.");
            return;
          }

          var order = data.order;
          renderStatusCard(order);
          renderProgressBar(order);
          renderEstimate(order);
          renderProgress(order);
          renderDeliveredInfo(order);
          renderSummary(order);

          var statusSection = document.getElementById('ac-track-status');
          var summarySection = document.getElementById('ac-track-summary');
          revealSection(statusSection);
          revealSection(summarySection);

          scrollToCurrentMilestone();
        })
        .catch(function () {
          submitButton.classList.remove('is-loading');
          submitButton.disabled = false;
          hideResultSections();
          showError("Something went wrong while looking up your order. Please try again in a moment.");
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
